"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var cache = __importStar(require("./cache"));
var UNDEFINED = "undefined";
var FUNCTION = "function";
var WHOLE_NUMBER = /^\d+$/;
/**
 * Retrieves the value from the source based on the provided key
 * @param {unknown} source The source from which to retrieve the value.
 * @param {string|number} key The key to look up in the source object.
 * @param {string} currentPath The current path being traversed in the object hierarchy.
 * @param {string} fullPath The full path to the current key being evaluated.
 * @returns {unknown} The value retrieved from the source object.
 */
var getValue = function (source, key, currentPath, fullPath) {
    if (cache.has(currentPath))
        return cache.get(currentPath);
    // Early return if source is not an object
    if (typeof source === UNDEFINED || source === null) {
        cache.set(currentPath, undefined);
        return undefined;
    }
    // Check if key is a numeric string once and reuse the result
    var numericKey = WHOLE_NUMBER.test(key) ? Number(key) : null;
    // We assign `value` to the element at the `numericKey`
    // index if `source` is an array and `key` is a numeric
    // string, otherwise we treat `source` as an object and
    // assign `value` to the property with the name `key`.
    var value = numericKey !== null && Array.isArray(source)
        ? source[numericKey]
        : source[key];
    // If the value is a function, call it with the provided
    // parameters
    if (typeof value === FUNCTION)
        value = value.call(source, key, currentPath, fullPath);
    cache.set(currentPath, value);
    return value;
};
exports.default = getValue;
